import { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { scrollToId } from "./shared";

const LINKS = [
  { id: "pricing", label: "The Plan", testId: "nav-link-plan" },
  { id: "custom", label: "Custom Work", testId: "nav-link-custom" },
  { id: "how-it-works", label: "How It Works", testId: "nav-link-how" },
  { id: "faq", label: "FAQ", testId: "nav-link-faq" },
];

const Nav = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-40 backdrop-blur-md bg-[#faf7f2]/90 border-b border-[#e7e1d6]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <button
          data-testid="nav-brand"
          onClick={() => window.__lenis?.scrollTo(0)}
          className="font-serif text-lg sm:text-xl font-semibold text-[#16324a] tracking-tight"
        >
          Chesco <span className="italic text-[#c99a43]">Local Presence</span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={l.testId}
              onClick={() => go(l.id)}
              className="text-sm font-medium text-[#334e68] hover:text-[#c99a43] transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <a
            data-testid="nav-phone-link"
            href="tel:6104534448"
            className="hidden lg:inline-flex items-center gap-2 text-sm font-semibold text-[#16324a] hover:text-[#c99a43] transition-colors duration-300"
          >
            <Phone size={15} /> (610) 453-4448
          </a>
          <button
            data-testid="nav-cta-button"
            onClick={() => go("contact")}
            className="bg-[#16324a] text-[#faf7f2] text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-[#c99a43] hover:text-[#16324a] transition-colors duration-300"
          >
            I'm interested!
          </button>
        </nav>

        <button
          data-testid="nav-mobile-menu-button"
          onClick={() => setOpen(!open)}
          className="md:hidden p-2 text-[#16324a]"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#e7e1d6] bg-[#faf7f2] px-4 py-4 flex flex-col gap-1">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`${l.testId}-mobile`}
              onClick={() => go(l.id)}
              className="text-left py-3 text-base font-medium text-[#334e68] border-b border-[#e7e1d6]/60"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta-button-mobile"
            onClick={() => go("contact")}
            className="mt-3 bg-[#16324a] text-[#faf7f2] text-sm font-semibold px-5 py-3 rounded-full"
          >
            I'm interested!
          </button>
        </div>
      )}
    </header>
  );
};

export default Nav;
